import DataSubjectAccessRequestService from '../services/dsar-service';

export const dataSubjectAccessRequest = {
  namespaced: true,
  state: {
    dsar: null,
    DataSubjectAccessRequestOwners: [],
  },
  actions: {
    initDSAR({ commit }, dsar) {
      commit('setDSAR', dsar);
    },
    create({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestService.create(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setDSAR', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    get({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setDSAR', null);
      return DataSubjectAccessRequestService.get(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setDSAR', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    update({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestService.update(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setDSAR', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    listDataSubjectAccessRequestOwners({ commit }) {
      return DataSubjectAccessRequestService.listDataSubjectAccessRequestOwners().then((result) => {
        commit('setDataSubjectAccessRequestOwners', result);
      });
    },
  },
  mutations: {
    setDSAR(state, newState) {
      state.dsar = newState;
    },
    setDataSubjectAccessRequestOwners(state, owners) {
      state.DataSubjectAccessRequestOwners = owners;
    },
  },
};
